import { render, staticRenderFns } from "./DialogAddUser.vue?vue&type=template&id=1cb54a69"
import script from "./DialogAddUser.vue?vue&type=script&lang=js"
export * from "./DialogAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb54a69')) {
      api.createRecord('1cb54a69', component.options)
    } else {
      api.reload('1cb54a69', component.options)
    }
    module.hot.accept("./DialogAddUser.vue?vue&type=template&id=1cb54a69", function () {
      api.rerender('1cb54a69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/components/Dialogs/DialogAddUser.vue"
export default component.exports